import type { TOC } from '@ember/component/template-only';
import { concat } from '@ember/helper';
import GeneralEmbeddedApp from 'lumen/components/general/embedded-app';
import type HotelSettingsSpiderSpiderDashboardController from 'lumen/controllers/hotel/settings/spider/spider-dashboard';
import getEnv from 'lumen/helpers/get-env';

interface HotelSettingsSpiderSpiderDashboardSignature {
  Args: {
    controller: HotelSettingsSpiderSpiderDashboardController;
    model: unknown;
  };
}

<template>
  <GeneralEmbeddedApp
    {{! @glint-expect-error: Incorrect type }}
    @baseURL={{getEnv "spiderIframeURL"}}
    @id="spider-settings"
    @query={{@controller.iframeQPs}}
    @url={{if
      @controller.model.spiderId
      (concat "/hotels/" @controller.model.spiderId "/" @controller.dashboard)
      "/hotels/new"
    }}
  />
</template> satisfies TOC<HotelSettingsSpiderSpiderDashboardSignature>;
